module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-icon-75.1e95017b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Slot/images/slot-icon-75.png
// module id = 3367
// module chunks = 11